import { render, staticRenderFns } from "./ExpenseColumns.vue?vue&type=template&id=4cd9dc4e&scoped=true"
import script from "./ExpenseColumns.vue?vue&type=script&lang=js"
export * from "./ExpenseColumns.vue?vue&type=script&lang=js"
import style0 from "./ExpenseColumns.vue?vue&type=style&index=0&id=4cd9dc4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd9dc4e",
  null
  
)

export default component.exports